<template>
  <div class="container-fluid">
    <panel
      Title="دسترسی منوها"
      Des="در این منو می‌توانید دسترسی کاربران به بخش های مختلف را کنترل کنید. همچنین می‌توانید نام نمایش داده شده در منو را تغییر دهید."
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>
    <div class="row">
      <div class="col-1"></div>
      <div class="col-12 col-md-10 mx-md-2 p-md-3">
        <net-pa-card>
          <template slot="header">
            <h6 class="text-right">
              <i class="fas fa-check-double"></i> دسترسی منوها
            </h6>
          </template>
          <template slot="content">
            <div class="col-12 table-responsive">
              <div class="row mb-2">
                <div class="col-md-9"></div>
                <div class="col-md-3 col-12">
                  <button
                    v-if="EditMode"
                    class="btn rounded btn-success w-100"
                    @click="updatemenu"
                  >
                    ثبت اطلاعات
                  </button>
                  <button
                    v-else
                    class="btn rounded btn-warning w-100"
                    @click="EditMode = !EditMode"
                  >
                    اصلاح
                  </button>
                </div>
              </div>
              <table class="table table-bordered table-hover rounded">
                <thead>
                  <tr>
                    <th>ردیف</th>
                    <!-- <th>ایکون</th> -->
                    <th class="text-center">نام منو</th>
                    <!-- <th class="text-center">مسیر</th> -->
                    <th class="text-center">دسترسی</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in Menu" :key="index">
                    <td>{{ index }}</td>
                    <!-- <td> <i :class="item.menuIcone"></i></td> -->
                    <td>
                      <input
                        :disabled="!EditMode"
                        type="text"
                        v-model="Menu[index].name"
                      />
                    </td>
                    <!-- <td>{{item.routeName}}/</td> -->
                    <td>
                      <span class="text-center">
                        <div class="custom-control custom-switch">
                          <input
                            type="checkbox"
                            :disabled="index == 0 ? true : !EditMode"
                            class="custom-control-input InputText"
                            :checked="Menu[index].isMenu"
                            v-model="Menu[index].isMenu"
                            :id="Menu[index].id + 'active'"
                          />
                          <label
                            class="custom-control-label mt-2 Pointer"
                            :for="Menu[index].id + 'active'"
                          ></label>
                        </div>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="row">
                <div class="col-md-9"></div>
                <div class="col-md-3 col-12">
                  <button
                    v-if="EditMode"
                    class="btn rounded btn-success w-100"
                    @click="updatemenu"
                  >
                    ثبت اطلاعات
                  </button>
                  <button
                    v-else
                    class="btn rounded btn-warning w-100"
                    @click="EditMode = !EditMode"
                  >
                    اصلاح
                  </button>
                </div>
              </div>
            </div>
          </template>
        </net-pa-card>
      </div>
      <div class="col-1"></div>
    </div>
  </div>
</template>
<script>
import NetPaCard from "../Tools/NetPa/NetPaCard.vue";
import Panel from "../Tools/NetPa/Panel.vue";

export default {
  components: { NetPaCard, Panel },
  data() {
    return {
      Menu: [],
      EditMode: false,
    };
  },
  methods: {
    readMenus() {
      var DataAxiosRead = {
        ArryfildValue: {},
        Method: "Post",
        Action: "Menu/getAllmenus",
        Token: this.$session.get("TokenNetPa"),
      };
      this.$PostData(DataAxiosRead).then((data) => {
        this.Menu = data;
      });
    },
    updatemenu() {
      this.$store.state.loading = true;
      var DataAxiosUpdate = {
        ArryfildValue: {},
        Method: "Post",
        Action: "Menu/Updatemenus",
        Token: this.$session.get("TokenNetPa"),
      };
      var formdata = new FormData();
      formdata.append("listMenu", JSON.stringify(this.Menu));
      DataAxiosUpdate.ArryfildValue = formdata;
      this.$PostFormData(DataAxiosUpdate).then((data) => {
        this.$store.state.loading = false;
        if (data.status == "OK") {
          this.$mySweetDefault(
            "عملیات موفق!",
            "تغییرات با موفقیت ذخیره شد. برای اعمال یکبار از برنامه خارج شوید و دوباره وارد شوید",
            "success",
            2000,
          );
        } else {
          this.$mySweetDefault(
            "خطا!",
            "در ثبت اطلاعات مشکلی رخ داده است. لطفا دوباره تلاش کنید",
            "danger",
            2000,
          );
        }
        this.EditMode = !this.EditMode;
        this.ClearCashMemoryServer();
      });
    },
    ClearCashMemoryServer() {
      var DataAxiosClearCash = {
        ArryfildValue: {},
        Method: "Post",
        Action: "Menu/ClearCashMemory",
        Token: this.$session.get("TokenNetPa"),
      };
      this.$PostData(DataAxiosClearCash).then((data) => {
        if (data == true) {
          this.readMenus();
        } else {
          this.$mySweetDefault(
            "عدم به روز رسانی حافظه",
            "در خالی کردن حافظه موقت سرور مشکلی پیش آمده .",
            "warning",
            2000,
          );
        }
      });
    },
  },
  created() {
    this.readMenus();
  },
};
</script>
<style>
table td {
  position: relative;
}

table td input {
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  margin: 0;
  height: 100%;
  width: 100%;
  border: none;
  padding: 10px;
  box-sizing: border-box;
}
</style>
